import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { CreateCommunicationsform, GraphMicrosoftBaseURL, Attachments, value, UploadURL, IngnoreFileExtensions } from "../../config/config";
import { BACKEND_ERROR_MAP } from '../../utils/Constants';
import { RootState } from './store';
import { commitBlocks, uploadBlobChunks } from '../../scripts/azureuploadhandler'
import { FastRewind } from '@mui/icons-material';

export const SaveCommuncationLegacy = createAsyncThunk(
  'communication/SaveCommuncation',
  async (Cdata: any, { rejectWithValue }) => {
    try {
      Cdata.filter = "";

      let index = 1;
      Cdata.UploadFileAttachments.forEach(element => {
        if (element.filename !== "") {
          let file = new File([element.blobfile], element.filename);
          switch (index) {
            case 1: Cdata.UploadSingleAttachments1 = file; break;
            case 2: Cdata.UploadSingleAttachments2 = file; break;
            case 3: Cdata.UploadSingleAttachments3 = file; break;
            case 4: Cdata.UploadSingleAttachments4 = file; break;
            case 5: Cdata.UploadSingleAttachments5 = file; break;
            case 6: Cdata.UploadSingleAttachments6 = file; break;
          }
          index = index + 1;
        }
      });

      const response = await apiClient.post(CreateCommunicationsform, Cdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: '*/*',
          'mode': 'outlook'
        },
      });

      return response.data; // success → goes to fulfilled
    } catch (err: any) {
      // Handle API error
      if (err.response && err.response.status === 400) {
        return rejectWithValue(err.response.data); // pass backend { error: "..." }
      }
      return rejectWithValue({ error: err.message || "Unexpected error" });
    }
  }
);

// File chunk is disabled for releasing Sprint 116
export const SaveCommuncation = createAsyncThunk(
  "communication/SaveCommuncation",
  async (Cdata: any, { rejectWithValue, getState, dispatch }) => {
    console.log("cdata before calling1", JSON.stringify(Cdata, null, 2));
    try {
      Cdata.filter = "";
      let IngnoreFileUpload = false;

      if (Cdata.CreateClarraDocs == null)
        Cdata.CreateClarraDocs = false

      if (Cdata.CreateCommunication == false && Cdata.CreateClarraDocs == false)
        IngnoreFileUpload = true;
      if (!IngnoreFileUpload) {
        const attachments = Cdata.UploadFileAttachments || [];
        const totalSize = attachments.reduce((sum, f) => sum + (f.blobfile?.size || 0), 0);
        let uploadedSize = 0;
        dispatch(setUploadProgress(0));

        const uploadedFiles: any[] = [];
        let index = 0;
        // Validation Not supported file extetions
        const IgnoreFileExtensionsSet = new Set(
          IngnoreFileExtensions.split(",").map(ext => ext.trim().toLowerCase())
        );
        if (Cdata.UploadFileAttachments !== null) {
          for (const file of Cdata.UploadFileAttachments) {
            const extension = file.filename.split(".").pop()?.toLowerCase();
            if (extension && IgnoreFileExtensionsSet.has(extension)) {
              let fileerrormsg = "Clarra does not allow " + extension.toUpperCase() + " or other executable files to ensure platform security";
              return rejectWithValue({ error: fileerrormsg });
            }
          }
        }

        if (Cdata.UploadFileAttachments?.length) {

          for (const element of Cdata.UploadFileAttachments) {

            if (!element?.filename) continue;
            var UploadURLRequest = {
              "filename": element.filename,
              "CreateCommunication": Cdata.CreateCommunication,
              "CreateTimeSlip": Cdata.CreateTimeSlip,
              "CreateClarraDocs": (Cdata.CreateClarraDocs) ? Cdata.CreateClarraDocs : false,
              "Matter": Cdata.Matter
            }
            console.log("UploadURLRequest before calling1", JSON.stringify(UploadURLRequest, null, 2));

            let uploadUrl;
            let blobname;
            try {
              const { data } = await apiClient.post(UploadURL, UploadURLRequest, {
                headers: {
                  'Content-Type': "application/json",
                  'mode': 'outlook'
                },
              }
              );

              uploadUrl = data.uploadUrl;
              blobname = data.blobname;

            } catch (error: any) {
              const errormessage = error?.response?.data?.error ||
                error?.response?.data?.message ||
                "Failed to fetch Document upload Url";

              return rejectWithValue({ error: errormessage });
            }

            // Upload actual file
            // const blockIds = await uploadBlobChunks(uploadUrl, element.blobfile);
            const blockIds = await uploadBlobChunks(uploadUrl, element.blobfile, (chunkSize) => {
              if (totalSize > 0) {
                uploadedSize += chunkSize;
                const progress = Math.round((uploadedSize / totalSize) * 100);
                dispatch(setUploadProgress(progress));
              }
            });
            await commitBlocks(uploadUrl, blockIds);

            uploadedFiles.push({
              Id: index++,
              DownloadURL: `blob://${blobname}`,
              Name: element.filename
            });
          }

          Cdata.ZapierDownloadURL = (uploadedFiles != null && uploadedFiles.length > 0) ? uploadedFiles : null;
          delete Cdata.UploadFileAttachments;

          if (Cdata.CreateClarraDocs !== null && Cdata.CreateClarraDocs == true) {
            Cdata.ClarraDocs.ZapierDownloadURL = (uploadedFiles != null && uploadedFiles.length > 0) ? uploadedFiles : null;;

            if (Cdata.ClarraDocs != null)
              delete Cdata.ClarraDocs.UploadFileAttachments;
          }

        }
      }
      else {
         delete Cdata.UploadFileAttachments;
          if (Cdata.ClarraDocs != null)
              delete Cdata.ClarraDocs.UploadFileAttachments;
      }
      //console.log("Cdata before calling api", JSON.stringify(Cdata, null, 2));
      const response = await apiClient.post(
        CreateCommunicationsform,
        Cdata,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: "*/*",
            mode: "outlook"
          }
        }
      );

      return response.data;

    } catch (err: any) {


      console.error("SaveCommuncation error:", err);

      let apierrorMessage = err?.response?.data?.error || "Error";
      if (apierrorMessage == "Error") {
        apierrorMessage = err?.response?.data || "Error to log"
      }
      const state = getState() as RootState;
      const uiDictionary = state.labels.uiDictionary;

      if (uiDictionary) {
        Object.keys(BACKEND_ERROR_MAP).forEach(errorWord => {
          const dictKey = BACKEND_ERROR_MAP[errorWord];
          const label = uiDictionary[dictKey];
          if (label) {
            apierrorMessage = apierrorMessage.replace(new RegExp(errorWord, "gi"), label);
          }
        });
      }

      return rejectWithValue({ error: apierrorMessage });
    }
  }
);
const communicationSlice = createSlice({
  name: 'communication',
  initialState: {
    communication: null,
    loading: false,
    error: null,
    uploadProgress: 0,
  },
  reducers: {
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(SaveCommuncation.pending, (state) => {
        state.loading = true;
        state.error = null;

      })
      .addCase(SaveCommuncation.fulfilled, (state, action) => {
        state.loading = false;
        state.communication = action.payload;
        state.uploadProgress = 0;
      })
      .addCase(SaveCommuncation.rejected, (state, action) => {
        state.loading = false;
        state.uploadProgress = 0;
        if (action.payload) {
          state.error = action.payload;
        } else {
          state.error = action.error.message;
        }
      });
  }
});

export const { setUploadProgress } = communicationSlice.actions;
export default communicationSlice.reducer;